import { faFaceSmile, faSmileBeam } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Contact = () => {
  return (
    <div className="min-h-screen hero">
      <div className="card max-w-4xl m-auto text-neutral-content">
        <div className="card-body items-center text-center">
        <FontAwesomeIcon icon={faFaceSmile} className="text-7xl text-primary-focus py-5" />
          <p className="text-2xl">
            Thanks for taking the time to reach out. How can I help you today?
          </p>
        </div>
        <form
          className="mb-5 p-2"
          action="https://formspree.io/f/xlezvbbe"
          method="POST"
        >
          <div className="grid gap-5 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 my-4">
            <div className="form-control">
              <input
                type="text"
                placeholder="Name"
                name="name"
                className="input input-bordered input-primary"
              />
            </div>
            <div className="form-control">
              <input
                type="email"
                placeholder="Email"
                name="email"
                className="input input-bordered input-primary"
              />
            </div>
          </div>
          <div className="form-control my-4">
            <input
              type="text"
              placeholder="Subject"
              name="subject"
              className="input input-bordered input-primary"
            />
          </div>
          <div className="form-control my-4">
            <textarea
              placeholder="Message"
              name="message"
              className="textarea textarea-primary"
              rows="5"
            ></textarea>
          </div>
          <div className="grid lg:justify-end md:justify-center sm:justify-start items-center">
            <button className="btn btn-primary" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
